/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

const getEmailList = (state) => state.emails;
export const getEmails = createSelector(getEmailList, (emails) => emails.items);
